<script setup lang="ts">
import type { NuxtError } from '#app'

import { amplitudeConfig, trackEvent } from '@shared/lib/amplitude'
import { HeadingH4, TextSecondary } from '@shared/ui/typography'
import { BtnPrimary } from '@shared/ui/button'

import errorImage from './error-illustration.svg'

defineOptions({
  name: 'PageError',
})

const props = defineProps<{
  error: () => NuxtError
}>()

trackEvent(amplitudeConfig.events.pageNotFound, {
  error: String(props.error),
})

</script>

<template>
  <div class="error-page">
    <div class="error-page__image-wrapper">
      <img
        :src="errorImage"
        alt="Error illustration"
        class="error-page__image"
      >
    </div>

    <div class="error-page__content">
      <div class="error-page__text-wrapper">
        <HeadingH4>
          Oops...something went wrong 👀
        </HeadingH4>

        <TextSecondary>
          Accidents happen, but feel free to go back to the home page and try again
        </TextSecondary>
      </div>

      <BtnPrimary
        text="Go back to home page"
        @click="$router.push('/')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./error.scss" />
